module.exports = __webpack_public_path__ + "img/phone.3e80dd90.svg";